import { AlertTriangleIcon } from "lucide-react";
import { Card, CardContent } from "./card";

export function ErrorBox({
	message,
	fullscreen,
}: {
	message: string;
	fullscreen?: boolean;
}) {
	// If fullScreen is true, use fixed positioning for the entire viewport
	const fixed = (fullscreen ?? false) ? " fixed" : "";
	return (
		<div
			className={`flex flex-col w-full h-full items-center justify-center insert-0${fixed}`}
		>
			<Card>
				{/* <CardHeader>
          <CardTitle>Error</CardTitle>
        </CardHeader> */}
				<CardContent className="flex gap-2">
					<AlertTriangleIcon /> {message}
				</CardContent>
			</Card>
		</div>
	);
}
